/* eslint-disable */
import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as oidcReducer } from "redux-oidc";
import toast from "./toastReducer";
import currentPage from "./currentPageReducer";
import managePage from "./managePageReducer";
import manageForm from "./manageFormReducer";
import manageExcelTemplates from "./manageExcelTemplateReducer";
import manageExcelTemplateDownload from "./manageExcelTemplateDownload";
import manageMenus from "./manageMenusReducer";
import entityRecord from "./entityRecordReducer";
import esgRecord from "./esgReducer";
import manageToolbarSelections from "./manageToolbarSelectionsReducer";
import checklist from "./checklistReducer";
import getLoggedInUserReducer from "./getLoggedInUserReducer";
import previousUpload from "./previousUploadReducer";
import pptReducer from "./pptReducer";
import getIrcSlotData from "./getIrcSlotReducer";
import dealTeamGetORdel from "./dealTeamReducer";
import manualUpdateReducer from "./manualUpdateReducer";
import getDTMetricReducer from "./getDTMetricReducer";
import getIrReportReducer from "./irReportReducer";
import previousEntityReducer from "./previousEntityReducer";
import manageFilterValueReducer from "./manageFilterValueReducer";
import ReloadResultTemplate from "./ReloadResultTemplate";
import proposalTrackerReducer from "./proposalTackerReducer";
import getPillarReducer from "./getpillarnameReducer";
import getEventValueReducer from "./getEventValueReducer";
import showSearchReducer from "./showSearchReducer";
import userRolesReducer from "./userRoles.reducer";
import userReducer from "./userReducer";


// Please maintain the sequence alphabetically, ignoring the first two.
const rootReducer = combineReducers({
  routing: routerReducer,
  oidc: oidcReducer,
  checklist,
  currentPage,
  dealTeamGetORdel,
  entityRecord,
  esgRecord,
  getDTMetricReducer,
  getEventValueStore: getEventValueReducer,
  getIrcSlotData,
  getIrReportReducer,
  getLoggedInUserReducer,
  getpillarfromstore: getPillarReducer,
  manageExcelTemplateDownload,
  manageExcelTemplates,
  manageFilterValueReducer,
  manageForm,
  manageMenus,
  managePage,
  manageToolbarSelections,
  manualUpdateReducer,
  pptReducer,
  previousEntity: previousEntityReducer,
  previousUpload,
  proposalTrackerReducer,
  ReloadResultTemplate,
  showSearch: showSearchReducer,
  toast,
  userRoles: userRolesReducer,
  allUsers: userReducer
});

const mainReducer = (state, action) => {
  if (action.type === "RESET_STATE") {
    state = undefined;
  }
  return rootReducer(state, action);
};

export default mainReducer;
